module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('datepicker', {
    ref: "fromDate",
    attrs: {
      "name": "from",
      "placeholder": _vm.placeholder,
      "language": _vm.language,
      "monday-first": true,
      "format": _vm.format,
      "disabled": _vm.disabled,
      "disabled-picker": _vm.disabledPicker,
      "calendar-button": true,
      "clear-button-icon": "glyphicon glyphicon-remove",
      "calendar-button-icon": "glyphicon glyphicon-time"
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92799d04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datepicker.vue
// module id = 1338
// module chunks = 2